import classNames from "classnames";
import { Video } from "@circle-react-shared/Video/index";

export interface DisplayMediaProps {
  hasContent?: boolean;
  isVideo?: boolean;
  mediaURL: string;
}

export const BannerMedia = ({
  hasContent = false,
  isVideo = false,
  mediaURL,
}: DisplayMediaProps) => {
  if (isVideo) {
    return (
      <div className="h-auto w-full">
        <Video url={mediaURL} />
      </div>
    );
  }

  return (
    <img
      loading="lazy"
      alt=""
      className={classNames(
        "border-primary h-[240px] w-full rounded-none border-x border-t object-cover",
        {
          "md:rounded-t-lg": hasContent,
          "md:rounded-lg": !hasContent,
        },
      )}
      src={mediaURL}
      data-testid="welcome-media-content"
    />
  );
};
